import React, { useEffect, useContext, useState } from "react"
import { useTranslation } from "react-i18next"
import { Card, FlexView, Table, Spinner, Button, Link } from "../components/common"
import { Input, DatePicker } from 'components/form'
import styled from "styled-components"
import { SafetyStockContext } from "stores/SafetyStockStore"
import moment from 'moment'
import { AppContext } from "stores/AppStore"
import { Multiselect } from 'multiselect-react-dropdown'
import { toast } from "react-toastify"
import { formatNm } from "../utils/format"

const Grid = styled(FlexView)`
  flex: 1;
  width: 100%;
  display: grid;
  align-items: stretch;
  grid-template-columns: 25% 25% 50%;
  max-height: 400px;

  @media screen and (max-width: 700px) {
    grid-template-columns: 100%;
  }
`
const multiselectCss = { 
  multiselectContainer: {},
  searchBox: {
    minHeight: '28px'
  }, 
  inputField: {}, 
  chips: { 
    borderRadius: '5px', 
    // maxWidth: '150px', 
    textOverflow: 'ellipsis' 
  }, 
  optionContainer: { 
    fontSize: '12px', 
    boxShadow: 'rgba(0, 0, 0, 0.11) 0px 0.3px 0.9px, rgba(0, 0, 0, 0.133) 0px 1.6px 3.6px', 
    borderRadius: '6px' 
  },
  // option: { 
  //   padding: '3px 10px' 
  // } 
}

const SafetyPlanningNm = () => {
  const { setPageSubtitle } = useContext(AppContext)
  const { t } = useTranslation()
  const { getSafetyStockPlanningNm, safetyStockCrudPlanning } = useContext(SafetyStockContext)

  const [table, setTable] = useState([])
  const [loadingFilters, setLoadingFilters] = useState(false)
  const [clients, setClients] = useState()
  const [nms, setNms] = useState()
  const [qtdPlan, setQtdPlan] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [selectedClient, setSelectedClient] = useState()
  const [selectedNm, setSelectedNm] = useState()
  const [dataFilterRows, setDataFilterRows] = useState()
  const [outDate, setOutDate] = useState()
  const [qtdOut, setQtdOut] = useState()
  const [replacementDate, setReplacementDate] = useState()

  const [idNm, setIdNm] = useState()
  const [idPlanning, setIdPlanning] = useState()

  const DatePickerReplacement = props => {
    return <DatePicker value={replacementDate} onChange={setReplacementDate} {...props} />
  }
 
  const DatePickerOut = props => {
    return <DatePicker value={outDate} onChange={setOutDate} {...props} />
  }

  const [edit, setEdit] = useState(false)

  const LabelMultiselect = ({ label, loading }) => {
    return (
      <FlexView flexDirection="row" justifyContent="flex-start" margin="4px 0px">
        <FlexView color="gray" fontSize="medium" fontWeight="700">{label}:</FlexView>
        {loading ? <Spinner style={{ margin: "0px 10px" }} size="medium" /> : <></>}
      </FlexView>
    )
  }
  

  useEffect(() => {
    setPageSubtitle(t('safety.pageTitle'))
  }, [setPageSubtitle, t])

  useEffect(() => {
    setLoadingFilters(true)
    setClients()
    setNms()
    setQtdPlan()
    setSelectedClient()
    setSelectedNm()
    setDataFilterRows()
    
    getSafetyStockPlanningNm({ init: true }).then(data => {
      if (typeof(data) == 'string') {
          data = JSON.parse(data);
      }
      setClients(data.filterData.clients)
      setNms(data.filterData.nms)
      setDataFilterRows(data.filterData.geral)
      setTable(data.tableData)
      setLoadingFilters(false)
    })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const onClientSelect = (selectedList) => {
    setSelectedClient(selectedList)
    if (!dataFilterRows || dataFilterRows.length > 0) {
      const filterClient = dataFilterRows.filter(row => row.idClient === selectedList[0].value);
      setNms(filterClient.map(({ nm }) => ({ value: nm, label: nm })))
    }
  }
  
  const onNmSelect = (selectedList) => {
    setSelectedNm(selectedList)
    if (!dataFilterRows || dataFilterRows.length > 0) {
      const filterNm = dataFilterRows.filter(row => row.idClient === selectedClient[0].value && row.nm === selectedList[0].value)
      setQtdPlan(filterNm[0].qtdPlan)
      setIdNm(filterNm[0].id)
    }
  }

  const columns = [
    {
      Header: t("safety.planning.table.dscCustomer"),
      accessor: "client",
      id: "client",
    },
    {
      Header: t("safety.planning.table.idClient"),
      accessor: "idClient",
      id: "idClient",
    },
    {
      Header: t("safety.planning.table.nm"),
      accessor: (row) => formatNm(row.nm),
      id: "nm",
    },
    {
      Header: t("safety.planning.table.qtdPlan"),
      accessor: "qtdPlan",
      id: "qtdPlan",
    },
    {
      Header: t("safety.planning.table.qtdOut"),
      accessor: "qtdOut",
      id: "qtdOut",
    },
    {
      Header: t("safety.planning.table.outDate"),
      accessor: row =>new Date(row.outDate).toLocaleDateString('pt-br', { timeZone: 'utc' }),
        // moment(row.outDate).format('DD/MM/YYYY'),
      id: "outDate",
    },

   
    {
      Header: t("safety.planning.table.replacementDate"),
      accessor: row => new Date(row.replacementDate).toLocaleDateString('pt-br', { timeZone: 'utc' }),
      // moment(row.replacementDate).format('DD/MM/YYYY'),
      id: "replacementDate",
    },
    {
      Header: t("safety.planning.table.creationDate"),
      accessor: row =>  new Date(row.creationDate).toLocaleDateString('pt-br', {timeZone: 'utc'}),
      // moment(row.creationDate).format('DD/MM/YYYY'),
      id: "creationDate",
    },
    {
      Header: t("safety.table.edit"),
      accessor: (row) => <Link onClick={ () =>  onEditClick(row)} >Editar </Link>,
      id: "edit",
    },
    {
      Header: t("safety.table.delete"),
      accessor: (row) => <Link onClick={() => onDeleteClick(row)} >Deletar </Link>,
      id: "delete",
    }
  ]

  const onEditClick = (row) => {
    setEdit(true)
    setSelectedClient([{ value: row.customer, label: row.client }])
    setSelectedNm([{ value: row.nm, label: row.nm }])
    setQtdOut(row.qtdOut)
    setQtdPlan(row.qtdPlan)
    setIdNm(row.id)
    setIdPlanning(row.idPlanning)
    setReplacementDate(moment(`${moment(row.replacementDate).format('DD/MM/YYYY')} 01:10:10`, 'DD/MM/YYYY HH:mm:ss'))
    setOutDate(moment(`${moment(row.outDate).format('DD/MM/YYYY')} 01:10:10`, 'DD/MM/YYYY HH:mm:ss'))
  }

  const onCancelClick = () => {
    setEdit(false)
    setSelectedClient()
    setSelectedNm()
    setQtdOut('')
    setQtdPlan('')
    setReplacementDate()
    setOutDate()
  }

  const validateForm = () => {
    if (!selectedClient || selectedClient.length === 0) {
      toast.error(t('safety.errors.clientRequired'));
      return false;
    }
    if (!selectedNm || selectedNm.length === 0) {
      toast.error(t('safety.errors.nmRequired'));
      return false;
    }
    if (!qtdOut || isNaN(Number(qtdOut)) || Number(qtdOut) <= 0) {
      toast.error(t('safety.errors.qtdOutRequired'));
      return false;
    }
    if (!outDate) {
      toast.error(t('safety.errors.outDateRequired'));
      return false;
    }
    if (!replacementDate) {
      toast.error(t('safety.errors.replacementDateRequired'));
      return false;
    }
    return true;
  }

  const onUpdateClick = (row) => {
    if (!validateForm())
      return;

    setIsLoading(true)
    safetyStockCrudPlanning({
      type: 'update',
      id: idPlanning,
      qtdOut: qtdOut,
      replacementDate: replacementDate,
      outDate: outDate
     }).then(data => {
       setTable(data.tableData)
       onCancelClick()
       setLoadingFilters(false)
       setIsLoading(false)
     }).catch(error => {
      toast.error(t('errors.' + error))
       setIsLoading(false)
     })
  }

  const onDeleteClick = (row) => {
    setIsLoading(true)
    safetyStockCrudPlanning({
      type: 'delete',
      idPlanning: row.idPlanning,
      idNm: row.id
    }).then(data => {
      setTable(data.tableData)
      setLoadingFilters(false)
      setIsLoading(false)
    }).catch(error => {
      toast.error(t('errors.' + error))
      setIsLoading(false)
    })
  }
  
  const onSaveClick = () => {
    if (!validateForm())
      return;

    setIsLoading(true)
    safetyStockCrudPlanning({
      type: 'save',
      id: idNm,
      qtdOut: qtdOut,
      replacementDate: replacementDate,
      outDate: outDate
     }).then(data => {
       setTable(data.tableData)
       onCancelClick()
       setLoadingFilters(false)
       setIsLoading(false)
     }).catch(error => {
      toast.error(t('errors.' + error))
      setIsLoading(false)
    })
  }
   
      
   const handleInputChange = (event) => {
    event.persist()
    setQtdOut(event.target.value)
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      onSaveClick()
    }
  }
 
  return (
    <>
      <Grid>
        <FlexView flex="1" position="relative" alignSelf="stretch">
          <FlexView flexDirection="row"  margin="16px 250px 0px" padding="0px 10px">
            <FlexView flexDirection="column"   margin="0px 5px 0px 0px" padding="0px">
              <LabelMultiselect label={t('safety.register.client')} />
              <Multiselect selectionLimit={1} selectedValues={selectedClient} options={clients} id="client"  onSelect={onClientSelect} onRemove={onClientSelect} displayValue="label" showCheckbox={true} closeOnSelect={true} placeholder="Search..."
                emptyRecordMsg="No values to select" style={multiselectCss} loading={loadingFilters} loadingMessage="Loading Material..." />
              <LabelMultiselect label={t('safety.register.nm')} />
              <Multiselect selectionLimit={1} width="100%" selectedValues={selectedNm} options={nms}  id="nm"  onSelect={onNmSelect} onRemove={onNmSelect} displayValue="label" showCheckbox={true} closeOnSelect={true} placeholder="Search..."
                emptyRecordMsg="No values to select" style={multiselectCss} loading={loadingFilters} loadingMessage="Loading Purchase..." />
              <FlexView flexDirection="row" >
                <Input disable marginTop="8px" label={t('safety.planning.table.qtdPlan')} width="100%" onChange={handleInputChange} name="qtdPlan" value={qtdPlan} onKeyDown={handleKeyDown} /> &nbsp;&nbsp;&nbsp;
                <Input marginTop="8px" label={t('safety.planning.table.qtdOut')} width="100%" onChange={handleInputChange} name="qtdOut" value={qtdOut} onKeyDown={handleKeyDown} />
              </FlexView>
              <FlexView flexDirection="row" >
                <DatePickerOut label={t('safety.planning.table.outDate')} width="100%" name="outDate" />
                <DatePickerReplacement label={t('safety.planning.table.replacementDate')} width="100%" name="replacementDate"/> &nbsp;&nbsp;&nbsp;
              </FlexView>
              {
                edit
                  ?
                  <FlexView flexDirection="row"   margin="0px 5px 0px 0px" padding="0px">
                    <Button backgroundColor="primary" color="white" fontSize="big" onClick={onUpdateClick} >{t('safety.update')}</Button>&nbsp;&nbsp;&nbsp;
                    <Button backgroundColor="primary" color="white" fontSize="big" onClick={onCancelClick} >{t('safety.cancel')}</Button>
                  </FlexView>
                :
                <Button backgroundColor="primary" color="white" fontSize="big" onClick={onSaveClick} >{t('safety.save')}</Button>
              }
            </FlexView>
          </FlexView>
        </FlexView>
      </Grid>
      {
        isLoading ?
          <FlexView justifyContent="center" alignItems="center" width="100%" height="100%">
            <Spinner />
          </FlexView>
          :
          <Card alignSelf="stretch" padding="8px 16px" flex="1" >
            {
              table.length > 0 ?
                <Table width="100%"
                  columns={columns}
                  data={table}
                  sortable
                  elevation="none"
                  borderRadius="card"
                  paginated
                  margin="8px 16px"
                  style={{ whiteSpace: "nowrap" }}
                />
                :
                <FlexView flex="1" width="100%" height="100%" alignItems="center" padding="50px" fontSize="big" fontWeight="bold" color="gray" backgroundColor="transparent">
                  {/* <Spinner /> */}
                  No Data
                </FlexView>
            }
          </Card>
      }
       
    </>
  )
}

export default SafetyPlanningNm
